import {
  OutgoingEventProductDto,
  EventProductType,
  OutgoingEventProductQuestionDto
} from 'api/dtos/events/products';

// Common interface for form values with required fields for form handling
export interface FormValueDto {
  type: EventProductType;
  name: string;
  description: string;
  price: number;
  isPrivate: boolean;
  isActive: boolean;
  maxQuantity?: number;
  components?: Array<{ productId: string; quantity: number }>;
  purchaseRequirements?: {
    requiresApproval: boolean;
    questions: Array<OutgoingEventProductQuestionDto>;
    requiredOrganizationIds: string[];
    requiredAssociationIds: string[];
  };
  imageUrl?: string;
  startDate?: string;
  endDate?: string;
  canDelete?: boolean;
  isVisible?: boolean; // only used for updating pre-existing products
  purchases?: number; // number of tickets already sold
  [key: string]: any;
}

const computeInitialValues = (
  ticket: OutgoingEventProductDto,
  isTierPrivate: boolean,
  productType: EventProductType = 'admission'
): FormValueDto => {
  if (ticket) {
    const baseValues: FormValueDto = {
      type: ticket.type as EventProductType,
      name: ticket.name,
      description: ticket.description || '',
      price: ticket.price,
      isPrivate: ticket.isPrivate,
      isActive: ticket.isActive || true,
      imageUrl: ticket.imageUrl,
      startDate: ticket.startDate,
      endDate: ticket.endDate,
      canDelete: ticket.canDelete,
      isVisible: ticket.isVisible,
      purchases: ticket.purchases || 0,
      purchaseRequirements: {
        requiresApproval:
          ticket.purchaseRequirements?.requiresApproval || false,
        questions: ticket.purchaseRequirements?.questions || [],
        requiredOrganizationIds:
          ticket.purchaseRequirements?.requiredOrganizationIds || [],
        requiredAssociationIds:
          ticket.purchaseRequirements?.requiredAssociationIds || []
      }
    };

    if (ticket.type === 'bundle') {
      return {
        ...baseValues,
        components: ticket.components || []
      };
    }
    return {
      ...baseValues,
      maxQuantity: ticket.maxQuantity,
      purchaseRequirements: {
        requiresApproval:
          ticket.purchaseRequirements?.requiresApproval || false,
        questions: ticket.purchaseRequirements?.questions || [],
        requiredOrganizationIds:
          ticket.purchaseRequirements?.requiredOrganizationIds || [],
        requiredAssociationIds:
          ticket.purchaseRequirements?.requiredAssociationIds || []
      }
    };
  }
  // Creating a new product
  const baseValues: FormValueDto = {
    type: productType,
    name: '',
    description: '',
    price: null as unknown as number,
    isPrivate: isTierPrivate,
    isActive: true,
    canDelete: true,
    purchases: 0
  };

  if (productType === 'bundle') {
    return {
      ...baseValues,
      components: [],
      purchaseRequirements: {
        requiresApproval: false,
        questions: [],
        requiredOrganizationIds: [],
        requiredAssociationIds: []
      }
    };
  }
  return {
    ...baseValues,
    maxQuantity: undefined,
    purchaseRequirements: {
      requiresApproval: false,
      questions: [],
      requiredOrganizationIds: [],
      requiredAssociationIds: []
    }
  };
};

export default computeInitialValues;
